





















































import { Vue, Component, Prop } from 'vue-property-decorator'
import { LabItem, WingBlank, DialogHead } from '@/components/index'
@Component({
  components: {
    LabItem,
    WingBlank,
    DialogHead
  }
})
export default class Drawer extends Vue {
  /**
   * drawer 抽屉状态
   * drawerForm 抽屉表单
   * drawserTable1
   * drawerObj 数据
   *  */
  @Prop({ default: false }) drawer!: boolean
  @Prop({ default: false }) drawerObj!: any

drawerForm = {}
handleData() {
  const {
    planName,
    triggerTime,
    executeTime,
    taskName,
    typeName,
    content
  } = this.drawerObj
  const { webhook, params } = content
  const {
    name,
    code,
    url
  } = webhook

  const { drawserTable1, drawserTable2 } = this.handleParams(params)
  this.drawerForm = {
    drawer1: [
      { title: '计划名称', text: planName },
      { title: '计划触发时间', text: triggerTime },
      { title: '任务执行时间', text: executeTime }
    ],
    drawer2: [
      { title: '任务名称', text: taskName },
      { title: '任务类型', text: typeName },
      { title: 'webhook名称', text: name },
      { title: 'webhook编码', text: code },
      { title: '接口地址', text: url }
    ],

    drawserTable1,
    drawserTable2
  }
}
/**
 * 参数处理
 * data
 */
handleParams(data:any) {
  const _data = [...data]
  const drawserTable1:any = []
  const drawserTable2:any = []
  _data.forEach((item:any) => {
    const obj = {
      params: item.desc,
      name: item.value || '--',
      number: item.code
    }
    if (item.type === 'custom') {
      drawserTable1.push(obj)
    } else {
      drawserTable2.push(obj)
    }
  })

  return {
    drawserTable1,
    drawserTable2
  }
}
created() {
  this.handleData()
}

// 关闭按钮
handleClose() {
  this.$emit('on-handle-close')
}
}
